export const addRupeeSymbol = (string) => string?.replace('&#8377;', '₹');
